import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Table, Input, Button } from "reactstrap";
import { AiOutlineEdit, AiOutlineDelete } from "react-icons/ai";
import { Link } from "react-router-dom";
import { MdAdd } from "react-icons/md";
import axios from "axios";
import { toast } from "react-toastify";

const StatusSelect = ({ value, onChange }) => (
  <Input
    type="select"
    size="sm"
    value={Number(value) === 1 ? "1" : "0"}
    onChange={(e) => onChange(e.target.value)}
  >
    <option value="1">Active</option>
    <option value="0">Inactive</option>
  </Input>
);

const InnerLinePermissionIndex = () => {
  const {
    AuthReducer: { auth },
  } = useSelector((state) => state);
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchList = () => {
    if (!auth?.token) return;
    setLoading(true);
    axios
      .get("/api/admin/v1/inner-line-permission-list", {
        headers: { Authorization: `Bearer ${auth.token}` },
      })
      .then((res) => setList(res.data?.data || []))
      .catch((err) =>
        toast.error(err.response?.data?.message || "Failed to load list")
      )
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchList();
  }, [auth?.token]);

  const handleStatusChange = async (id, status) => {
    try {
      const res = await axios.put(
        `/api/admin/v1/inner-line-permission-status/${id}`,
        { status: Number(status) },
        { headers: { Authorization: `Bearer ${auth?.token}` } }
      );
      toast.success(res.data?.message || "Status updated successfully");
      fetchList();
    } catch (err) {
      toast.error(err.response?.data?.message || "Something went wrong");
    }
  };

  const handleDelete = (id) => {
    if (!window.confirm("Are you sure you want to delete this record?")) return;
    axios
      .delete(`/api/admin/v1/inner-line-permission-delete/${id}`, {
        headers: { Authorization: `Bearer ${auth?.token}` },
      })
      .then((res) => {
        toast.success(res.data?.message || "Deleted successfully");
        fetchList();
      })
      .catch((err) =>
        toast.error(err.response?.data?.message || "Something went wrong")
      );
  };

  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <div className="mb-4 d-flex align-items-center justify-content-between">
            <h5 className="mb-0 text-white fs-4">Inner Line Permission</h5>
            <Link to="/add-inner-line-permission">
              <Button className="bg-white text-black" size="sm">
                <span className="me-2">
                  <MdAdd size={22} />
                </span>
                Add Inner Line Permission
              </Button>
            </Link>
          </div>
        </div>
      </div>
      <div
        className="bg-white px-3 py-4 rounded-2 my-4"
        style={{ boxShadow: "4px 4px 18px rgba(0,0,0,0.15)" }}
      >
        <div className="col-md-12">
          <Table hover responsive>
            <thead>
              <tr>
                <th>SL. No.</th>
                <th>For</th>
                <th>State</th>
                <th>City</th>
                <th>Town</th>
                <th>Place</th>
                <th>Apply Permit</th>
                <th>Sections</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="10">Loading...</td>
                </tr>
              ) : !list.length ? (
                <tr>
                  <td colSpan="10">No data found</td>
                </tr>
              ) : (
                list.map((item, index) => (
                  <tr key={item.id}>
                    <th scope="row">{index + 1}</th>
                    <td className="text-capitalize">{item?.for || "-"}</td>
                    <td>{item?.state?.state_name || "-"}</td>
                    <td>{item?.city?.city_name || "-"}</td>
                    <td>{item?.town?.town_name || "-"}</td>
                    <td>{item?.place?.place_name || "-"}</td>
                    <td>{Number(item?.is_apply_permit) === 1 ? "Yes" : "No"}</td>
                    <td>
                      {Array.isArray(item?.content) ? item.content.length : 0}
                    </td>
                    <td>
                      <StatusSelect
                        value={item.status}
                        onChange={(value) => handleStatusChange(item.id, value)}
                      />
                    </td>
                    <td>
                      <div className="d-flex align-items-center">
                        <Link to={`/add-inner-line-permission/${item.id}`}>
                          <AiOutlineEdit
                            size={22}
                            className="text-warning me-3"
                          />
                        </Link>
                        <AiOutlineDelete
                          size={22}
                          className="text-danger"
                          style={{ cursor: "pointer" }}
                          onClick={() => handleDelete(item.id)}
                        />
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default InnerLinePermissionIndex;
